import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconUpload.tsx
const OutlinedFilledUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z" })
});
const OutlinedUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-143h94v143h502v-143h95v143q0 39-27.77 66.5T731-135H229Z" })
});
const RoundedFilledUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Zm204-510-82 82q-13.8 14-32.4 14-18.6 0-32.99-14.07-14.78-14.07-14.19-33.5Q272-616 286-631l160-161q7.17-6.91 16.33-10.95 9.16-4.05 17.91-4.05 8.76 0 17.71 4.05Q506.9-798.91 514-792l162 162q14 14 14 33.5T676.39-564q-14.79 15.08-34.09 14.54Q623-550 609-564l-82-81v276q0 19.75-13.68 33.37Q499.65-322 479.82-322q-19.82 0-33.32-13.63Q433-349.25 433-369v-276Z" })
});
const RoundedUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-135q-39.05 0-66.52-27.48Q135-189.95 135-229v-96q0-19.75 13.68-33.38Q162.35-372 182.18-372q19.82 0 33.32 13.62Q229-344.75 229-325v96h502v-96q0-19.75 13.68-33.38Q758.35-372 778.09-372q19.73 0 33.82 13.62Q826-344.75 826-325v96q0 39.05-27.77 66.52Q770.46-135 731-135H229Zm204-510-82 82q-13.8 14-32.4 14-18.6 0-32.99-14.07-14.78-14.07-14.19-33.5Q272-616 286-631l160-161q7.17-6.91 16.33-10.95 9.16-4.05 17.91-4.05 8.76 0 17.71 4.05Q506.9-798.91 514-792l162 162q14 14 14 33.5T676.39-564q-14.79 15.08-34.09 14.54Q623-550 609-564l-82-81v276q0 19.75-13.68 33.37Q499.65-322 479.82-322q-19.82 0-33.32-13.63Q433-349.25 433-369v-276Z" })
});
const SharpFilledUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM135-135v-237h94v143h502v-143h95v237H135Z" })
});
const SharpUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-322v-323L319-530l-68-67 229-229 229 229-68 67-114-115v323h-94ZM135-135v-237h94v143h502v-143h95v237H135Z" })
});
const componentMap = {
	outlined: OutlinedUpload,
	"outlined-fill": OutlinedFilledUpload,
	rounded: RoundedUpload,
	"rounded-fill": RoundedFilledUpload,
	sharp: SharpUpload,
	"sharp-fill": SharpFilledUpload
};
const IconUpload = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconUpload };